import React, { useState } from "react";
import { Formik } from "formik";
import axios from "axios";
import { Input, message } from "antd";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function Verify() {
  const [initialState] = useState({
    otp: null,
  });
  const [loading, setLoading] = useState(false);

  const requestOTP = (email, setFieldValue) => {
    setLoading(true);
    axios
      .post(window.API_PREFIX + "users/api/post/generate-otp", { email })
      .then((res) => {
        message.success(res.data.message);
        setFieldValue("otpSent", true);
      })
      .catch((err) => {
        setFieldValue("emailError", "Invalid email address");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-inner">
        <Formik
          initialValues={initialState}
          onSubmit={(values) => {
            var url = window.API_PREFIX + "users/api/post/verify-otp";
            const requestOptions = {
              data: values,
            };
            setLoading(true);
            axios
              .post(url, requestOptions)
              .then((res) => {
                message.success(res.data.message);
              })
              .catch((err) => {})
              .finally(() => setLoading(false));
          }}
        >
          {({ handleSubmit, values, setFieldValue, errors, touched }) => (
            <div>
              <h3>Verify</h3>

              <div className="mb-3">
                <label>OTP</label>
                <Input
                  type="text"
                  className="form-control"
                  placeholder="Enter OTP to verify your email"
                  name="name"
                  value={values.name}
                  onChange={(e) => setFieldValue("name", e.target.value)}
                />
                <p className="forgot-password text-left">
                  <span
                    onClick={() => {
                      const email = sessionStorage.getItem("username");
                      requestOTP(email);
                    }}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    Resend OTP
                  </span>
                </p>
              </div>
              <div className="d-grid">
                <button type="submit" className="btn" onClick={handleSubmit}>
                  Verify
                </button>
              </div>
            </div>
          )}
        </Formik>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </div>
  );
}
export default Verify;
